module.exports = __webpack_public_path__ + "img/护理-3.69bed715.png";